import { render, staticRenderFns } from "./PayoneerCard.vue?vue&type=template&id=3ea92b3b&"
import script from "./PayoneerCard.vue?vue&type=script&lang=js&"
export * from "./PayoneerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports